export const features = {
  dayPresets: false,
  timePresets: false,
}
